/**
 * 離脱防止ダイアログ表示の処理
 */
export type ExitIntentDialogReturnType = {
  beforeUnloadHandler: (event: BeforeUnloadEvent) => void;
};
export const exitIntentDialog = (): ExitIntentDialogReturnType => {
  const beforeUnloadHandler = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = '診断手続きを終了します。\nここまでのデータがすべて削除されますが、よろしいですか？';
  };

  window.addEventListener('beforeunload', beforeUnloadHandler);

  return {
    beforeUnloadHandler,
  }
};
